import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectTestFeedbackApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-test-feedback'
  }

}